import r from "./td-longtail-vue-components177.js";
/* empty css                              */
import t from "./td-longtail-vue-components98.js";
var o = function() {
  var e = this, a = e._self._c, n = e._self._setupProxy;
  return n.energyLabel || e.energyClass ? a("div", { staticClass: "energy-label", class: n.containerClass }, [n.energyClassName ? a(n.Icon, { attrs: { "energy-class": n.energyClassName, reverse: e.reverse, tag: e.isNotClickable ? "span" : void 0, type: e.isNotClickable ? "span" : void 0 }, on: { click: n.openEnergyModal } }) : e._e(), n.energyLabel?.products && n.energyLabel.products.length > 0 && !e.noDataSheet ? a(n.Datasheet, { staticClass: "energy-label__datasheet", attrs: { "align-dropdown": n.alignDropdown, "is-internal-link": e.isInternalLink, products: n.energyLabel.products }, on: { "open-document": (s) => e.$emit("open-document", s) } }) : e._e()], 1) : e._e();
}, l = [], i = /* @__PURE__ */ t(
  r,
  o,
  l,
  !1,
  null,
  "555cb02a"
);
const g = i.exports;
export {
  g as default
};
